import type { UserRoles } from "~enums/userRoles";
import { userRolesByPriority } from "../../constants/userRolesByPriority";
import { userRolesConfig } from "../../constants/userRolesConfig";

const findHighestRoleToManagePermissions = (userRoles: UserRoles[]): UserRoles => {
  // default to lowest possible role
  if (userRoles.length === 0) {
    return userRolesByPriority[userRolesByPriority.length - 1];
  }

  const rolesSortedByPriority = userRoles.sort((a, b) => userRolesByPriority.indexOf(a) - userRolesByPriority.indexOf(b));

  return userRoles.find((role) => userRolesConfig[role]?.canAssignRoles?.length > 0) ?? rolesSortedByPriority[0];
};

export default findHighestRoleToManagePermissions;
